module.exports = __webpack_public_path__ + "img/reg-surf-party.1237cbf5.webp";